import { BaseRequestConfig } from '../../framework/BaseRequestConfig';

export class Net {
    protected basePath: string = '/';

    constructor(protected $http: ng.IHttpService, basePath?: string) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    public http(url: string, param: any, method: string): ng.IHttpPromise<any> {
        let path: string = this.basePath + url;
        let httpRequestParams: BaseRequestConfig = {
            method: method, url: path, unique: true, screenId: path };
        let newParam: any = this.createParam(param);
        if (method === 'GET') {
            httpRequestParams.params = newParam;
        } else {
            httpRequestParams.data = newParam;
        }
        return this.$http(httpRequestParams);
    }

    public get(url: string, param: any): ng.IHttpPromise<any> {
        return this.http(url, param, 'GET');
    }

    public post(url: string, param: any): ng.IHttpPromise<any> {
        return this.http(url, param, 'POST');
    }

    public createParam(param: any): any {
        let newParam: any = {};
        if (param) {
            Object.keys(param).forEach((key: any): void => {
                if (param[key] instanceof Date) {
                    newParam[key] = this.formatDate(param[key]);
                } else {
                    newParam[key] = param[key];
                }
            });
        } else {
            newParam = param;
        }
        return newParam;
    }

    public formatDate(date: Date): string {
        let month: string = '' + (date.getMonth() + 1);
        let day: string = '' + date.getDate();
        let year: string = '' + date.getFullYear();
        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }
        return [year, month, day].join('-');
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/extends_fw/Net.ts
 **/